import controllerDataConfigApi from '@/api/config/controllerDataConfig'
import { queryKeys } from '@/constant/common'
import { CreateController } from '@/types/controller'
import { getApiErrorMessage } from '@/helpers/notify'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { AxiosError } from 'axios'
import toast from 'react-hot-toast'

async function createController(payload: CreateController): Promise<void> {
  await controllerDataConfigApi.create(payload)
}
function useAddController() {
  const queryClient = useQueryClient()

  return useMutation((payload: CreateController) => createController(payload), {
    onSuccess: () => {
      queryClient.invalidateQueries([queryKeys.controller])
      queryClient.invalidateQueries([queryKeys.stations])
    },
    onError: (error: AxiosError<any>) => {
      // The only error reporting three of the four callers have, and it read
      // `Message` alone — so a body spelt `{ message: "bad request" }` raised a
      // toast with nothing in it and the caller's generic fallback beside it
      // (SCRUM-1032 QC, 21 Sep). The shared helper reads either spelling.
      toast.error(getApiErrorMessage(error))
    },
  })
}

export default useAddController
